<template>
  <div>
    <div class="price" :style="[priceStyle]">
      <slot name="text"></slot>
      <div v-if="text" class="text" :style="[textStyle]">{{ text }}</div>
      <div class="price-unit" :style="[priceUnitStyle]">￥</div>
      <div class="price-integer" :style="[priceIntegerStyle]">{{ handlePrice(price).integer }}</div>
      <div class="price-decimal" :style="[priceDecimalStyle]">
        .{{ handlePrice(price).decimal }}
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from 'vue'

defineProps({
  text: {
    type: String,
    default: ''
  },
  price: {
    type: [String, Number],
    default: ''
  },
  priceStyle: {
    type: Object,
    default: () => ({})
  },
  textStyle: {
    type: Object,
    default: () => ({})
  },
  priceUnitStyle: {
    type: Object,
    default: () => ({})
  },
  priceIntegerStyle: {
    type: Object,
    default: () => ({})
  },
  priceDecimalStyle: {
    type: Object,
    default: () => ({})
  }
})

// 处理价格
const handlePrice = price => {
  // 价格转换并切割为整数、小数
  const priceArr = price.toString().split('.')
  if (priceArr.length > 1) {
    return {
      integer: priceArr[0],
      decimal: priceArr[1]
    }
  } else {
    return {
      integer: priceArr[0],
      decimal: '00'
    }
  }
}
</script>
<style scoped lang="scss">
.price {
  display: flex;
  align-items: baseline;
  .text {
    font-weight: bold;
    font-size: 14px;
    color: #9e9e9e;
  }
  .price-unit {
    font-weight: 600;
    font-size: 12px;
    color: #f84f4f;
  }
  .price-integer {
    color: #f84f4f;
    font-size: 22px;
    font-family: PingFangSC;
    font-weight: 600;
  }
  .price-decimal {
    color: #f84f4f;
    font-size: 12px;
    font-family: PingFangSC;
    font-weight: 600;
  }
}
</style>
